import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faStethoscope, faUserTie, faHandsHolding } from '@fortawesome/free-solid-svg-icons';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const VolunteerSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const titleRef = useScrollReveal();
  const introRef = useScrollReveal();
  const card1Ref = useScrollReveal();
  const card2Ref = useScrollReveal();
  const card3Ref = useScrollReveal();
  const card4Ref = useScrollReveal();

  return (
    <section className="volunteer-section">
      <div className="container">
        <h2 ref={titleRef} className="section-title scroll-reveal">{t('volunteer.title')}</h2>
        <p ref={introRef} className="volunteer-intro scroll-reveal">
          {t('volunteer.intro')}
        </p>

        <div className="volunteer-grid">
          <div ref={card1Ref} className="volunteer-card scroll-reveal">
            <div className="volunteer-icon">
              <FontAwesomeIcon icon={faCode} />
            </div>
            <h3 className="volunteer-title">{t('volunteer.developer.title')}</h3>
            <p className="volunteer-desc">
              {t('volunteer.developer.description')}
            </p>
            <ul className="volunteer-skills">
              <li>• {t('volunteer.developer.skills.react')}</li>
              <li>• {t('volunteer.developer.skills.mobile')}</li>
              <li>• {t('volunteer.developer.skills.design')}</li>
              <li>• {t('volunteer.developer.skills.database')}</li>
            </ul>
            <button className="volunteer-btn" onClick={() => navigate('/volunteer/developer')}>
              {t('volunteer.developer.apply')}
            </button>
          </div>

          <div ref={card2Ref} className="volunteer-card scroll-reveal">
            <div className="volunteer-icon">
              <FontAwesomeIcon icon={faStethoscope} />
            </div>
            <h3 className="volunteer-title">{t('volunteer.medical.title')}</h3>
            <p className="volunteer-desc">
              {t('volunteer.medical.description')}
            </p>
            <ul className="volunteer-skills">
              <li>• {t('volunteer.medical.skills.surgeon')}</li>
              <li>• {t('volunteer.medical.skills.emergency')}</li>
              <li>• {t('volunteer.medical.skills.nurse')}</li>
              <li>• {t('volunteer.medical.skills.admin')}</li>
            </ul>
            <button className="volunteer-btn" onClick={() => navigate('/volunteer/medical')}>
              {t('volunteer.medical.apply')}
            </button>
          </div>

          <div ref={card3Ref} className="volunteer-card scroll-reveal">
            <div className="volunteer-icon">
              <FontAwesomeIcon icon={faUserTie} />
            </div>
            <h3 className="volunteer-title">{t('volunteer.admin.title')}</h3>
            <p className="volunteer-desc">
              {t('volunteer.admin.description')}
            </p>
            <ul className="volunteer-skills">
              <li>• {t('volunteer.admin.skills.project')}</li>
              <li>• {t('volunteer.admin.skills.marketing')}</li>
              <li>• {t('volunteer.admin.skills.accounting')}</li>
              <li>• {t('volunteer.admin.skills.customer')}</li>
            </ul>
            <button className="volunteer-btn" onClick={() => navigate('/volunteer/admin')}>
              {t('volunteer.admin.apply')}
            </button>
          </div>

          <div ref={card4Ref} className="volunteer-card scroll-reveal">
            <div className="volunteer-icon">
              <FontAwesomeIcon icon={faHandsHolding} />
            </div>
            <h3 className="volunteer-title">{t('volunteer.sponsor.title')}</h3>
            <p className="volunteer-desc">
              {t('volunteer.sponsor.description')}
            </p>
            <ul className="volunteer-skills">
              <li>• {t('volunteer.sponsor.skills.recommend')}</li>
              <li>• {t('volunteer.sponsor.skills.corporate')}</li>
              <li>• {t('volunteer.sponsor.skills.needs')}</li>
              <li>• {t('volunteer.sponsor.skills.networking')}</li>
            </ul>
            <button className="volunteer-btn" onClick={() => navigate('/volunteer/sponsor')}>
              {t('volunteer.sponsor.apply')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VolunteerSection;
